import React, { useState, useEffect } from "react";
import axios from "axios";
import configData from "../config.json";
import { useNavigate, useLocation } from "react-router-dom";
import * as Icon from "react-bootstrap-icons";

const Login = () => {

  const [inputData, setInputData] = useState({
    email: "",
    passcode: "",
    branchcode: "",
  });

  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    localStorage.removeItem("branchID");
    localStorage.removeItem("regName");
    localStorage.removeItem("branchName");
    localStorage.removeItem("branchcode");
  }, []);

  const handleInput = (e) => {
    const { name, value } = e.target;
    setInputData({ ...inputData, [name]: value });
  };

  const handleSubmit = async (e) => {

    e.preventDefault();

    try {

      setLoading(true);

      const allinputData = {
        email: inputData.email,
        passcode: inputData.passcode,
        branchcode: inputData.branchcode,
      };

      let res = await axios.post(configData.SERVER_URL + "/loginEntry",allinputData);

      if (res.status === 200) {

        if (res.data[0].acount === 1) {

          localStorage.setItem("branchID", res.data[0].branchID);
          localStorage.setItem("regName", res.data[0].regName);
          localStorage.setItem("branchName", res.data[0].branchName);
          localStorage.setItem("branchcode", res.data[0].branchcode);
          localStorage.setItem("user", JSON.stringify(res.data[0]));

          navigate("/medical");

        } else {
          alert("Invalid Email ID or Password");
        }

      } else {
        alert("System Error");
      }

    } catch (err) {

      console.log(err);
      alert("Server Connection Failed");

    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="container-fluid"
      style={{
        minHeight: "100vh",
        background:
          "linear-gradient(to right,rgb(230, 240, 255),rgb(245, 247, 250))",
      }}
    >
      <div className="row justify-content-center align-items-center min-vh-100">

        <div className="col-lg-4 col-md-6 col-sm-10">

          <div
            className="card border-0 shadow-lg"
            style={{
              borderRadius: "25px",
              overflow: "hidden",
            }}
          >

            {/* Header */}

            <div
              className="text-center text-white py-4"
              style={{
                background:
                  "linear-gradient(to right, #0d6efd, #0dcaf0)",
              }}
            >

              <div
                className="bg-white text-primary rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3 shadow"
                style={{
                  width: "80px",
                  height: "80px",
                }}
              >
                <Icon.HeartPulseFill size={38} />
              </div>

              <h2 className="fw-bold mb-1">
                BSEC-MEDICAL
              </h2>

              <p className="mb-0">
                Medical Management System
              </p>

            </div>

            {/* Form */}

            <div className="card-body p-5">

              <form onSubmit={handleSubmit}>

                {/* Company Code */}

                <div className="mb-4">

                  <label className="form-label fw-semibold">
                    Company Code
                  </label>

                  <div className="input-group">

                    <span className="input-group-text bg-light">
                      <Icon.Building />
                    </span>

                    <input
                      type="text"
                      className="form-control"
                      id="branchcode"
                      name="branchcode"
                      placeholder="Enter Company Code"
                      value={inputData.branchcode}
                      onChange={handleInput}
                      required
                    />

                  </div>
                </div>

                {/* Email */}

                <div className="mb-4">

                  <label className="form-label fw-semibold">
                    Login ID
                  </label>

                  <div className="input-group">

                    <span className="input-group-text bg-light">
                      <Icon.PersonFill />
                    </span>

                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      name="email"
                      placeholder="name@example.com"
                      value={inputData.email}
                      onChange={handleInput}
                      required
                    />

                  </div>
                </div>

                {/* Password */}

                <div className="mb-4">

                  <label className="form-label fw-semibold">
                    Password
                  </label>

                  <div className="input-group">

                    <span className="input-group-text bg-light">
                      <Icon.LockFill />
                    </span>

                    <input
                      type="password"
                      className="form-control"
                      id="passcode"
                      name="passcode"
                      placeholder="Enter Password"
                      value={inputData.passcode}
                      onChange={handleInput}
                      required
                    />

                  </div>
                </div>

                {/* Button */}

                <div className="d-grid mt-4">

                  <button
                    className="btn btn-primary btn-lg fw-semibold"
                    type="submit"
                    disabled={loading}
                    style={{
                      borderRadius: "12px",
                    }}
                  >
                    {loading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                        ></span>
                        Signing In...
                      </>
                    ) : (
                      <>
                        <Icon.BoxArrowInRight className="me-2" />
                        Login
                      </>
                    )}
                  </button>

                </div>

              </form>

            </div>

            {/* Footer */}

            <div className="text-center py-3 bg-light text-muted small">
              © 2026 MIS & ICT Department, BSEC
            </div>

          </div>

        </div>

      </div>
    </div>
  );
};

export default Login;